<template>
    <el-dialog class="el-dialogs" title="分享知识模型" width="500px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="110px">
            <el-form-item label="选择用户：" prop="userList">
                <div class="selectData" @click='selectUserData'>
                    <i class="el-icon-plus"></i>
                </div>
                <div class="tipsD">邀请的用户可以获得所选知识模型的查看和引用权限。</div>
                <div class="userContent">
                    <el-tag
                        v-for="item in searchForm.userList"
                        :key="item.id"
                        closable
                        @close="deleteTag(item)">
                        {{ item.departmentName }}
                    </el-tag>
                </div>
            </el-form-item>
        </el-form>
        <contacts ref="contacts" @selectuserData="selectuserData"></contacts>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Contacts from "@/views/modules/academic/academic/learningNode/contacts.vue";

export default {
    name: "shareKnow",
    components: {Contacts},
    data() {
        return {
            visible: false,
            searchForm:{
                userList:[],
            },
            rules:{},
            selectData:{},
        }
    },

    methods: {
        init(selectData) {
            this.visible = true
            this.searchForm.userList = []
            this.selectData = selectData
        },

        selectUserData(){
            this.$refs.contacts.init(this.searchForm.userList)
        },

        selectuserData(data){
            this.searchForm.userList = data
        },

        deleteTag(row){
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.searchForm.userList = this.searchForm.userList.filter(item=>item.id != row.id)
            })
        },

        doSubmit(){
            if(this.searchForm.userList.length == 0){
                this.$message.warning('请至少选择一个分享用户')
                return
            }
            let ids = this.searchForm.userList.map(item=>{
                return item.id
            })
            this.$axios(this.api.academic.knowledgemodelShare, {
                id:this.selectData.id,
                ids,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('分享成功');
                    //更新我的未读信息
                    this.$store.commit('user/updateUserMessage')
                    this.visible = false
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
    },
}
</script>

<style scoped>
.selectData{
    width: 50px;
    height: 50px;
    border: 1px dashed rgb(192, 204, 218);
    border-radius: 5px;
    font-size: 18px;
    color: rgb(192, 204, 218);
    display: grid;
    place-items: center;
    cursor: pointer;
}

.tipsD{
    font-size: 10px;
    color: #7F97B1;
}

.userContent{
    height: 250px;
    overflow-y: auto;
}
</style>